import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'engineering-insights',
});

export const metricDetailsRouteRef = createRouteRef({
  id: 'engineering-insights-details',
});
